module.exports = __webpack_public_path__ + "static/media/zocalo9.f0cb9f30.jpg";